import React from 'react'

import {
  getTransactions,
  setTransactionsFilters,
} from '../../../store/transactions/transactionsActions'

// material-ui
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormLabel from '@material-ui/core/FormLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'

// types
interface Props {
  category: any
  setOpenModalFilter: any
  isOpenModalFilter: any
  onChangeFilterState: any
  dispatch: any
  state: any
}

export const Fieldset = ({
  category,
  setOpenModalFilter,
  isOpenModalFilter,
  onChangeFilterState,
  state,
  dispatch,
}: Props) => {
  const onClickApply = () => {
    dispatch(
      setTransactionsFilters(
        state.dateTo,
        state.dateFrom,
        state.type,
        state.resource,
        state.category
      )
    )
    setOpenModalFilter(false)
    dispatch(getTransactions())
  }
  return (
    <>
      <Dialog
        onClose={() => setOpenModalFilter(false)}
        open={isOpenModalFilter}
      >
        <DialogTitle>Filtros</DialogTitle>
        <DialogContent>
          <TextField
            type="date"
            label="Data inicial"
            value={state.dateFrom}
            onChange={onChangeFilterState('dateFrom')}
          />
          <TextField
            type="date"
            label="Data final"
            value={state.dateTo}
            onChange={onChangeFilterState('dateTo')}
          />
          {state.type === 'incomes' || state.type === 'expenses' ? (
            <FormControl
              component="fieldset"
              style={{ marginTop: 16, marginLeft: 25 }}
            >
              <Select
                value={state.category}
                onChange={onChangeFilterState('category')}
                placeholder="Name"
                displayEmpty
              >
                {category.map((item: any) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.name}
                  </MenuItem>
                ))}

                <MenuItem value={'all'}>Todos</MenuItem>
              </Select>
            </FormControl>
          ) : null}
          <FormControl component="fieldset" style={{ marginTop: 16 }}>
            <FormLabel component="legend">Tipo</FormLabel>
            <RadioGroup
              row
              value={state.type}
              onChange={onChangeFilterState('type')}
            >
              <FormControlLabel
                value="all"
                control={<Radio color="primary" />}
                label="Todos"
              />
              <FormControlLabel
                value="incomes"
                control={<Radio color="primary" />}
                label="Apenas receitas"
              />
              <FormControlLabel
                value="expenses"
                control={<Radio color="primary" />}
                label="Apenas despesas"
              />
            </RadioGroup>
          </FormControl>

          <FormControl component="fieldset" style={{ marginTop: 16 }}>
            <FormLabel component="legend">Recurso</FormLabel>
            <RadioGroup
              row
              value={state.resource}
              onChange={onChangeFilterState('resource')}
            >
              <FormControlLabel
                value="all"
                control={<Radio color="primary" />}
                label="Todos"
              />
              <FormControlLabel
                value="Caixa"
                control={<Radio color="primary" />}
                label="Caixa"
              />
              <FormControlLabel
                value="Conta"
                control={<Radio color="primary" />}
                label="Conta"
              />
              <FormControlLabel
                value="Outros"
                control={<Radio color="primary" />}
                label="Outros"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalFilter(false)}>Cancelar</Button>
          <Button onClick={onClickApply} color="primary">
            Aplicar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
